import victorCImg from "../../../../assets/pages/NewHome/client-victor-c.png";
import marcosVImg from "../../../../assets/pages/NewHome/client-marcos-v.png";
import carlosJImg from "../../../../assets/pages/NewHome/client-carlos-j.png";
import brunoRImg from "../../../../assets/pages/NewHome/client-bruno-r.png";
import tiagoAImg from "../../../../assets/pages/NewHome/client-tiago-a.png";

export const CLIENTS = [
  {
    statement:
      "Entrei em contato na segunda-feira a tarde, visitei o imóvel terça pela manhã e na terça a tarde já fui aprovado para alocar o imóvel.",
    name: "Carlos J",
    type: "Inquilino",
    img_url: carlosJImg,
  },
  {
    statement:
      "Coloquei meu imóvel para alugar com eles, e é realmente incrível a atenção, agilidade e cuidados que eles têm com tudo, desde o primeiro contato até a assinatura do contrato. Tudo muito agilizado e eficaz.",
    name: "Victor C",
    type: "Proprietário",
    img_url: victorCImg,
  },
  {
    statement:
      "Imobiliária corretíssima, conectada com o futuro, [...] O suporte às dúvidas sobre o imóvel é ótimo. Tratam todo tipo de assunto sobre o imóvel de forma rápida e honesta. O pessoal da vistoria e do financeiro são show de bola.",
    name: "Marcos V",
    type: "Inquilino",
    img_url: marcosVImg,
  },
  {
    statement:
      "Imobiliária de excelente qualidade. Sou inquilino em um imóvel e locador em outro. Gosto do atendimento e resoluções em tratativas necessárias.",
    name: "Bruno R",
    type: "Proprietário",
    img_url: brunoRImg,
  },
  {
    statement:
      "A 7Cantos possui uma equipe jovem, inovadora, talentosa, competente e compromissada. [...] Tanto para o proprietário como para o inquilino, os serviços são prestados com excelência, transparência e muito profissionalismo.",
    name: "Tiago A",
    type: "Inquilino",
    img_url: tiagoAImg,
  },
];
